export default function ExitByKeyController(view) {
  return evt => {
    switch (evt.key) {
      case " ":
      case "Escape":
        view.resolve();
        break;
    }
  };
}